import { getItem } from '../data/items.js';
import { belongsInWardrobe, planGrant } from './inventory.js';
/**
 * The account's chest (ADR 0079), as pure rules: what may go in, where a
 * deposit or a withdrawal lands, and who stands close enough. The chest is
 * shared by every character of an account; `StashService` applies these
 * under the account's lock and checks them all again there.
 */
/**
 * Places in an account's chest. The server reads the capacity through one
 * function (`StashService.capacityOf`), so a future premium subscription
 * raises it there and nowhere else; nothing premium exists yet.
 */
export const STASH_SIZE = 20;
/** The most places a chest can ever show: the ceiling the messages validate against. */
export const MAX_STASH_SIZE = 200;
/** Tiles from the chest, diagonals included, like the merchant's (`MERCHANT_REACH`). */
export const STASH_REACH = 2;
/** The chest of every village (`data/mobs.ts`), clicked like a keeper. */
export const STASH_MOB_ID = 'stash-chest';
/**
 * A bound piece belongs to its character (ADR 0013), and so do a quest's
 * bait, the camp's kit and every bound reward: the chest would hand it to
 * another. Looks and companions live in the wardrobe (ADR 0072), which is
 * already unlimited. A shop purchase still in its cooldown (ADR 0044) may
 * go in: it stays on the account, where a refund still finds it.
 */
export function stashBlock(instance, template) {
    if (belongsInWardrobe(template))
        return 'wardrobe';
    if (instance.bound)
        return 'bound';
    return null;
}
export function isStashable(instance, template = getItem(instance.templateId)) {
    return template !== undefined && stashBlock(instance, template) === null;
}
/**
 * Where `quantity` of a template lands in a bag or a chest: its unbound
 * stacks first, then free places in order, or null when it does not all fit.
 * A bound stack (a quest's reward) never takes in what comes from the chest,
 * or the newcomers would be bound with it.
 */
export function planStashPlacement(entries, template, quantity, size) {
    // A bound stack keeps its place but is no stack to pour into.
    const open = entries.map((entry) => entry.item.bound ? { ...entry, item: { ...entry.item, templateId: '' } } : entry);
    return planGrant(open, template, quantity, size);
}
/**
 * Whether a placement plan moves the whole row as it is: one new place for
 * all of it. The row then keeps its id, its affixes and its smith's level.
 */
export function movesWholeRow(plan, rowQuantity) {
    return plan.length === 1 && plan[0]?.itemId === null && plan[0].quantity === rowQuantity;
}
/** Within `STASH_REACH` tiles of one of these chests, diagonals included. */
export function withinStashReach(at, chests) {
    return chests.some((chest) => Math.max(Math.abs(chest.x - at.x), Math.abs(chest.y - at.y)) <= STASH_REACH);
}
//# sourceMappingURL=stash.js.map